/**
 *
 * Asynchronously loads the component for ProductManagementModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ProductManagementModule = lazyLoad(
  () => import('./index'),
  module => module.ProductManagementModule,
);
